import type { LoginHistory } from '@/types/UserHistory';

export const useUserHistory = () => {
  const { loginHistory, loadingUserHistory } = storeToRefs(
    useUserHistoryStore(),
  );

  const { setLoginHistory } = useUserHistoryStore();
  const { isAuthenticated } = storeToRefs(useAuthStore());

  async function getLoginHistory(page: number = 1) {
    if (!isAuthenticated.value) {
      return;
    }

    loadingUserHistory.value = true;

    const payload = `?page=${page}`;

    try {
      const { ApiService } = useApiService();

      await ApiService.get(`/bff/users/login-history${payload}`).then(
        (res: any) => {
          if (res && res.data) {
            setLoginHistory(res.data as LoginHistory);
          }
        },
      );
    } catch (error) {
      console.error({ error });
    } finally {
      loadingUserHistory.value = false;
    }
  }

  return {
    loginHistory,
    loadingUserHistory,
    getLoginHistory,
  };
};
